// removed by extract-text-webpack-plugin
module.exports = {"carouselFooter":"CarouselFooter__carouselFooter___ACBlE","footerCarouselComponent":"CarouselFooter__footerCarouselComponent___mopyl","disabledFooterCarouselComponent":"CarouselFooter__disabledFooterCarouselComponent___DrOMJ CarouselFooter__footerCarouselComponent___mopyl","footerHolder":"CarouselFooter__footerHolder___2YAug","footerCarouselButton":"CarouselFooter__footerCarouselButton___1zM3D","footerCarouselLabel":"CarouselFooter__footerCarouselLabel___208Bh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CarouselFooter/CarouselFooter.css
// module id = 987
// module chunks = 0